// Mock data for FREEAYTO website (Multi-Page)

export const FREEAYTO_LOGO = "https://customer-assets.emergentagent.com/job_c45bf878-4522-4309-8d35-3d4ca83f0b07/artifacts/csruqovk_6y1ysek2_f9b25d82-7133-4c05-b1a3-fae3c5a54596-Photoroom.png";

// Real founder portrait
export const KEANU_PORTRAIT = "https://customer-assets.emergentagent.com/job_strategy-performance/artifacts/aeb5uggb_000_PicturePeople-1_1763461456213%202.JPG";

// Real photos for "Fotos" gallery
export const PHOTO_GALLERY = [
  {
    id: "robi1",
    src: "https://customer-assets.emergentagent.com/job_strategy-performance/artifacts/3rgybyta_3ROBI%20%40%20CLUBONE-71.jpg",
  },
  {
    id: "robi2",
    src: "https://customer-assets.emergentagent.com/job_strategy-performance/artifacts/niqw7m6r_3ROBI%20%40%20CLUBONE-84.jpg",
  },
  {
    id: "robi3",
    src: "https://customer-assets.emergentagent.com/job_strategy-performance/artifacts/kysckdmm_3ROBI%20%40%20CLUBONE-87.jpg",
  },
];

// Videos
export const VIDEO_NOINTRO = "https://customer-assets.emergentagent.com/job_strategy-performance/artifacts/v0qnrocu_NOINTRO.mp4";
export const VIDEO_BALKAN = "https://customer-assets.emergentagent.com/job_strategy-performance/artifacts/wgziitbg_BALKAN%20GRILL%20FINAL.mp4";
export const VIDEO_FREEZY = "https://customer-assets.emergentagent.com/job_strategy-performance/artifacts/rqkhwgwm_FREEZY%20X%20CHRISTIANWOLF.mp4";
// Hero showreel (used on homepage)
export const VIDEO_HERO_SHOWREEL = "https://customer-assets-agu9un31.emergentagent.net/job_704440de-61b0-4999-9e6c-5853267ca016/artifacts/c37orrim_SEITE.mp4";

// External reference videos
export const EXT_VIDEO_TIKTOK_3M = "https://www.tiktok.com/@shopbackde/video/7426273868341431585";
export const EXT_VIDEO_IG_SUBWAY = "https://www.instagram.com/reels/C5BTIVqJzYv/";
export const EXT_VIDEO_IG_UGC = "https://www.instagram.com/reel/DXW76gvDefA/";

// Contact
export const CONTACT_EMAIL = "info@freeayto.de";
export const CONTACT_PHONE = "+49 177 5902856";
export const CONTACT_LOCATION = "Dortmund, Deutschland";

// Brand logo URLs (for client cards in Erfolge)
const LOGO_FIGHT_GYM = "https://customer-assets.emergentagent.com/job_strategy-performance/artifacts/gzxx47yz_FIGHT-GYM-LOGO-VECTOR-1024x555.png";
const LOGO_ALDI_SUED = "https://customer-assets.emergentagent.com/job_strategy-performance/artifacts/xcw5asdc_Aldi_Su%CC%88d_2017_logo.svg.png";
const LOGO_ALDI_NORD = "https://customer-assets.emergentagent.com/job_strategy-performance/artifacts/h65gpp99_ALDI_Nord_Logo_2015.png";
const LOGO_LOCO = "https://customer-assets.emergentagent.com/job_strategy-performance/artifacts/r47a5d2h_Loco_Chicken_Logo-910x1024-2.png";
const LOGO_MOVIE = "https://customer-assets.emergentagent.com/job_strategy-performance/artifacts/qaeju5v7_mt-logo.png";
const LOGO_ICK = "https://customer-assets.emergentagent.com/job_strategy-performance/artifacts/7brihiwk_ChatGPT%20Image%2026.%20Apr.%202026%2C%2017_37_42.png";
const LOGO_AM = "https://customer-assets.emergentagent.com/job_strategy-performance/artifacts/zpabpccc_am%20logo%2001.png";
const LOGO_PRIME = "https://customer-assets.emergentagent.com/job_strategy-performance/artifacts/3byembwe_prime-logo-2x.png";
const LOGO_MBG = "https://customer-assets.emergentagent.com/job_strategy-performance/artifacts/k3sp8xtg_MBG_Group_Logo.png";
const LOGO_MIX = "https://customer-assets.emergentagent.com/job_strategy-performance/artifacts/oqbmvao1_MIX_Markt_Logo.svg.png";
const LOGO_SUBWAY = "https://customer-assets.emergentagent.com/job_strategy-performance/artifacts/mr0b92l4_subway-3-logo-png-transparent.png";
const LOGO_NACHTRESIDENZ = "https://customer-assets.emergentagent.com/job_strategy-performance/artifacts/t4v1l2h3_Logo_Nachtresidenz_2.jpg";
const LOGO_AMAZON = "https://customer-assets.emergentagent.com/job_strategy-performance/artifacts/25dlisty_amazon-logo-editorial-icon-isolated-600nw-2333488123.jpg.webp";
const LOGO_FIVE_GUYS = "https://customer-assets.emergentagent.com/job_strategy-performance/artifacts/rxy9m4mh_Twitter_1024x512-1674473989321.jpg.webp";
const LOGO_SCHIWAGO = "https://customer-assets.emergentagent.com/job_strategy-performance/artifacts/9ioree54_schiwago_final.jpg";
const LOGO_D2D = "https://customer-assets-agu9un31.emergentagent.net/job_704440de-61b0-4999-9e6c-5853267ca016/artifacts/jrkeo572_d2dmasterclass-logo-neu-weiss-scaled.webp";

export const BRAND_LOGOS = {
  fightGym: { src: LOGO_FIGHT_GYM, bg: "dark" },
  aldiSued: { src: LOGO_ALDI_SUED, bg: "light" },
  aldiNord: { src: LOGO_ALDI_NORD, bg: "light" },
  locoChicken: { src: LOGO_LOCO, bg: "dark" },
  movieTavles: { src: LOGO_MOVIE, bg: "dark" },
  ick: { src: LOGO_ICK, bg: "dark" },
  alessandroMagno: { src: LOGO_AM, bg: "light" },
  prime: { src: LOGO_PRIME, bg: "dark" },
  mbg: { src: LOGO_MBG, bg: "dark" },
  mixMarkt: { src: LOGO_MIX, bg: "dark" },
  subway: { src: LOGO_SUBWAY, bg: "dark" },
  nachtresidenz: { src: LOGO_NACHTRESIDENZ, bg: "dark" },
  amazon: { src: LOGO_AMAZON, bg: "dark" },
  fiveGuys: { src: LOGO_FIVE_GUYS, bg: "light" },
  schiwago: { src: LOGO_SCHIWAGO, bg: "light" },
};

export const NAV_ITEMS = [
  { label: "Home", to: "/" },
  { label: "Leistungen", to: "/leistungen" },
  { label: "Erfolge", to: "/erfolge" },
  { label: "Team", to: "/team" },
  {
    label: "Kostenlose Tools",
    dropdown: [
      {
        label: "KI Video-Skript Ersteller",
        desc: "In 30 Sek. zum fertigen Skript",
        to: "/tools/video-skript",
        icon: "Sparkles",
      },
      {
        label: "Social Media Check",
        desc: "Wie gut ist dein Social Media wirklich?",
        to: "/tools/social-media-check",
        icon: "Activity",
      },
    ],
  },
  { label: "Kontakt", to: "/kontakt" },
];

// Hero stats with raw numeric values for animation
export const HERO_STATS = [
  { raw: 3700000, format: "compact", decimals: 1, suffix: "+", label: "TikTok Views", color: "text-pink-500" },
  { raw: 730000, format: "compact", decimals: 0, suffix: "+", label: "Instagram Reach", color: "text-orange-500" },
  { raw: 5, format: "default", suffix: "", label: "Top UGC Creator", color: "text-amber-400", showStar: true },
];

// Form Dropdown Options (for Kontaktformular)
export const LEISTUNG_OPTIONS = [
  "Positionierung",
  "Content Creation",
  "Social Media Betreuung",
  "Performance & Wachstum",
  "UGC Creator buchen",
  "Influencer-Marketing",
  "Sonstiges",
];

export const BUDGET_OPTIONS = [
  "< 2.000 €",
  "2.000 – 5.000 €",
  "5.000 – 10.000 €",
  "> 10.000 €",
  "Noch unklar",
];

// Trust elements for contact page
export const TRUST_BADGES = [
  { icon: "ShieldCheck", text: "Kostenlos & unverbindlich" },
  { icon: "Clock", text: "Antwort innerhalb 24h" },
  { icon: "Users", text: "50+ zufriedene Kunden" },
  { icon: "Star", text: "5★ Bewertungen" },
];

// Logos for "Bereits gearbeitet für / mit" marquee – ONLY real client logos
export const CLIENT_LOGOS = [
  { name: "D2D Masterclass", src: LOGO_D2D, bg: "light" },
  { name: "Fight Gym Bielefeld", src: LOGO_FIGHT_GYM, bg: "dark" },
  { name: "Aldi Süd", src: LOGO_ALDI_SUED, bg: "light" },
  { name: "Aldi Nord", src: LOGO_ALDI_NORD, bg: "light" },
  { name: "Loco Chicken", src: LOGO_LOCO, bg: "dark" },
  { name: "Movie Tavles", src: LOGO_MOVIE, bg: "dark" },
  { name: "ICK bin ein Berliner", src: LOGO_ICK, bg: "dark" },
  { name: "Alessandro Magno", src: LOGO_AM, bg: "light" },
  { name: "Prime Dance & Nightlife", src: LOGO_PRIME, bg: "dark" },
  { name: "MBG Group", src: LOGO_MBG, bg: "dark" },
  { name: "Mix Markt", src: LOGO_MIX, bg: "dark" },
  { name: "Subway", src: LOGO_SUBWAY, bg: "dark" },
  { name: "Nachtresidenz Düsseldorf", src: LOGO_NACHTRESIDENZ, bg: "dark" },
  { name: "Amazon", src: LOGO_AMAZON, bg: "dark" },
  { name: "Five Guys", src: LOGO_FIVE_GUYS, bg: "light" },
  { name: "Dr. Schiwago", src: LOGO_SCHIWAGO, bg: "light" },
];

export const SERVICES = [
  {
    id: 1,
    icon: "Target",
    title: "Positionierung",
    subtitle: "Klarheit. Wahrnehmung. Wirkung.",
    description:
      "Wir entwickeln eine Positionierung, die euch unverwechselbar macht – mit klaren Botschaften, einem starken Auftritt und einem System, das im Feed wirklich auffällt.",
    bullets: [
      "Strategische Positionierung",
      "Klare Brand-Botschaften",
      "Visuelles Rebranding",
      "Markenarchitektur",
    ],
  },
  {
    id: 2,
    icon: "Video",
    title: "Content Creation",
    subtitle: "Reels, TikToks, Imagefilme.",
    description:
      "Vom Konzept bis zum fertigen Cut – Content mit Hook, Re-Hook und CTA. Performance-getrieben. Mit Creator und Model vor der Kamera.",
    bullets: [
      "Reels / TikToks / Shorts",
      "Imagefilme & Werbespots",
      "Event- & Produktvideos",
      "Performance-Logik (Hook → CTA)",
    ],
  },
  {
    id: 3,
    icon: "Calendar",
    title: "Social Media Betreuung",
    subtitle: "Struktur statt Chaos.",
    description:
      "Redaktionsplan, Account-Pflege, Community-Basics, Konsistenz. Wir denken nicht in einzelnen Posts – wir bauen ein System.",
    bullets: [
      "Redaktionsstruktur",
      "Content-Planung & Posting",
      "Community-Basics",
      "Konsistenter Auftritt",
    ],
  },
  {
    id: 4,
    icon: "TrendingUp",
    title: "Performance & Wachstum",
    subtitle: "Aus Reichweite werden Anfragen.",
    description:
      "Content mit Ziel: mehr Anfragen, mehr Buchungen, mehr Umsatz. Social Media als Verkaufsfläche – nicht als Selbstdarstellung.",
    bullets: [
      "Hook & Re-Hook Strategie",
      "Storytelling & CTA",
      "Funnel-Logik",
      "Umsatzfokus",
    ],
  },
];

export const PROBLEM_POINTS = [
  {
    title: "Du postest regelmäßig …",
    text: "… aber bekommst keine echten Anfragen darüber rein.",
  },
  {
    title: "Reichweite ohne Wirkung",
    text: "Views steigen, aber Kunden, Buchungen oder Umsatz bleiben aus.",
  },
  {
    title: "Keine klare Wahrnehmung",
    text: "Niemand versteht auf den ersten Blick, wofür eure Marke steht.",
  },
  {
    title: "Kein System",
    text: "Content entsteht aus Aktionismus statt aus Strategie.",
  },
];

export const PROCESS_STEPS = [
  {
    step: "01",
    title: "Analyse & Kennenlernen",
    text: "Wir schauen uns euren aktuellen Auftritt, eure Zahlen und euer Ziel im Detail an. Ohne Marketing-Blabla.",
  },
  {
    step: "02",
    title: "Strategie & Positionierung",
    text: "Wir entwickeln den roten Faden: Wer seid ihr, wofür steht ihr, wie soll die Marke wahrgenommen werden?",
  },
  {
    step: "03",
    title: "Content-System aufbauen",
    text: "Wir produzieren den Content, bauen die Redaktionsstruktur und übernehmen Posting & Account-Pflege.",
  },
  {
    step: "04",
    title: "Performance & Skalierung",
    text: "Wir messen, was wirkt, optimieren laufend und skalieren das, was Anfragen und Umsatz bringt.",
  },
];

// Erfolge categories – only categories with real content
export const ERFOLGE_CATEGORIES = [
  { id: "premium", label: "Premium Brands", icon: "Crown" },
  { id: "stars", label: "Stars", icon: "Star" },
  { id: "clubs", label: "Clubs / Events", icon: "PartyPopper" },
  { id: "gastronomie", label: "Gastronomie", icon: "UtensilsCrossed" },
  { id: "fotos", label: "Fotos", icon: "Camera" },
  { id: "ugc", label: "UGC Content", icon: "Video" },
  { id: "sport", label: "Sport", icon: "Trophy" },
];

// Real items only – no fake placeholders
export const ERFOLGE_ITEMS = {
  premium: [
    { id: 1, type: "brand", title: "Aldi Süd", subtitle: "Premium Brand", logo: BRAND_LOGOS.aldiSued },
    { id: 2, type: "brand", title: "Aldi Nord", subtitle: "Premium Brand", logo: BRAND_LOGOS.aldiNord },
    { id: 3, type: "brand", title: "Amazon", subtitle: "Premium Brand", logo: BRAND_LOGOS.amazon },
    { id: 4, type: "brand", title: "MBG Group", subtitle: "Premium Brand", logo: BRAND_LOGOS.mbg },
    { id: 5, type: "brand", title: "Subway", subtitle: "Premium Brand", logo: BRAND_LOGOS.subway },
    { id: 6, type: "brand", title: "Five Guys", subtitle: "Premium Brand", logo: BRAND_LOGOS.fiveGuys },
  ],
  stars: [
    {
      id: 1,
      type: "video",
      title: "3Robi Clubshow",
      subtitle: "Live Event Coverage",
      metric: "Eventvideo",
      src: VIDEO_NOINTRO,
    },
    {
      id: 2,
      type: "video",
      title: "Freezy x Christianwolf",
      subtitle: "Artist Collaboration",
      metric: "Artist Content",
      src: VIDEO_FREEZY,
    },
  ],
  clubs: [
    { id: 1, type: "brand", title: "Nachtresidenz", subtitle: "Düsseldorf", logo: BRAND_LOGOS.nachtresidenz },
    { id: 2, type: "brand", title: "Prime Dance & Nightlife", subtitle: "Eventlocation", logo: BRAND_LOGOS.prime },
    { id: 3, type: "brand", title: "ICK bin ein Berliner", subtitle: "Berlin Brand", logo: BRAND_LOGOS.ick },
    { id: 4, type: "brand", title: "Movie Tavles", subtitle: "Entertainment", logo: BRAND_LOGOS.movieTavles },
  ],
  gastronomie: [
    {
      id: 1,
      type: "video",
      title: "Balkan Grill",
      subtitle: "Restaurant Campaign",
      metric: "Performance Spot",
      src: VIDEO_BALKAN,
    },
    { id: 2, type: "brand", title: "Subway", subtitle: "Quick Service", logo: BRAND_LOGOS.subway },
    { id: 3, type: "brand", title: "Five Guys", subtitle: "Premium Burger", logo: BRAND_LOGOS.fiveGuys },
    { id: 4, type: "brand", title: "Loco Chicken", subtitle: "Quick Service", logo: BRAND_LOGOS.locoChicken },
    { id: 5, type: "brand", title: "Dr. Schiwago", subtitle: "Restaurant · Bar · Lounge", logo: BRAND_LOGOS.schiwago },
    { id: 6, type: "brand", title: "Mix Markt", subtitle: "Retail / Food", logo: BRAND_LOGOS.mixMarkt },
  ],
  fotos: [
    { id: "f1", type: "photo", title: "3Robi @ ClubOne", subtitle: "Clubshow Coverage", src: PHOTO_GALLERY[0].src },
    { id: "f2", type: "photo", title: "3Robi @ ClubOne", subtitle: "Stage Performance", src: PHOTO_GALLERY[1].src },
    { id: "f3", type: "photo", title: "3Robi @ ClubOne", subtitle: "Crowd Energy", src: PHOTO_GALLERY[2].src },
  ],
  ugc: [
    {
      id: 1,
      type: "external",
      platform: "TikTok",
      title: "ShopBack DE – TikTok Hit",
      subtitle: "Performance Campaign",
      metric: "3.0M Views",
      url: EXT_VIDEO_TIKTOK_3M,
      brandLogo: null,
      gradient: "linear-gradient(135deg, #ff0050 0%, #000000 60%, #00f2ea 100%)",
    },
    {
      id: 2,
      type: "external",
      platform: "Instagram",
      title: "Subway – Reel",
      subtitle: "Brand Performance",
      metric: "730K Reach",
      url: EXT_VIDEO_IG_SUBWAY,
      brandLogo: BRAND_LOGOS.subway,
      gradient: "linear-gradient(135deg, #f09433 0%, #dc2743 50%, #bc1888 100%)",
    },
    {
      id: 3,
      type: "external",
      platform: "Instagram",
      title: "UGC Reel",
      subtitle: "Authentic Brand Content",
      metric: "5-stellige Views",
      url: EXT_VIDEO_IG_UGC,
      brandLogo: null,
      gradient: "linear-gradient(135deg, #833ab4 0%, #fd1d1d 50%, #fcb045 100%)",
    },
  ],
  sport: [
    { id: 1, type: "brand", title: "Fight Gym Bielefeld", subtitle: "Athletic Brand", logo: BRAND_LOGOS.fightGym },
    { id: 2, type: "brand", title: "Alessandro Magno", subtitle: "Personal Brand", logo: BRAND_LOGOS.alessandroMagno },
  ],
};

// Skript Generator
export const SCRIPT_BRANCHEN = [
  "Restaurant / Gastronomie",
  "Eventlocation / Club",
  "E-Commerce / Online-Shop",
  "Dienstleister B2B",
  "Personal Brand / Coach",
  "Fitnessstudio / Sport",
  "Beauty / Friseur / Kosmetik",
  "Immobilien",
  "Handwerk",
  "Auto / Mobilität",
  "Mode / Fashion",
  "Sonstiges",
];

export const SCRIPT_PLATFORMS = ["TikTok", "Instagram Reel", "YouTube Shorts"];

export const SCRIPT_GOALS = [
  "Mehr Anfragen / Buchungen",
  "Bekanntheit aufbauen",
  "Produkt / Angebot vorstellen",
  "Vertrauen aufbauen",
  "Verkauf direkt (Hard Sell)",
];

// Real video links shown on Homepage as "Erfolgreiche UGC Kampagnen"
export const PORTFOLIO_ADS = [
  {
    id: 1,
    type: "external",
    title: "ShopBack DE – TikTok Hit",
    views: "3.0M",
    platform: "TikTok",
    url: EXT_VIDEO_TIKTOK_3M,
    brandLogo: null,
    gradient: "linear-gradient(135deg, #ff0050 0%, #000000 55%, #00f2ea 100%)",
  },
  {
    id: 2,
    type: "external",
    title: "Subway – Reel",
    views: "730K",
    platform: "Instagram",
    url: EXT_VIDEO_IG_SUBWAY,
    brandLogo: BRAND_LOGOS.subway,
    gradient: "linear-gradient(135deg, #f09433 0%, #dc2743 50%, #bc1888 100%)",
  },
  {
    id: 3,
    type: "external",
    title: "UGC Reel",
    views: "5-stellig",
    platform: "Instagram",
    url: EXT_VIDEO_IG_UGC,
    brandLogo: null,
    gradient: "linear-gradient(135deg, #833ab4 0%, #fd1d1d 50%, #fcb045 100%)",
  },
];
